import { FallbackError } from "@core/domain/errors/fallback.error";
import { Either } from "@core/domain/types/either";
import { inject, injectable } from "inversify";
import { ProjectKanbanReportsDataSource } from "../datasource/project-kanban-reports.datasource";
import type {
    KanbanPendingByAssigneeBucketDto,
    KanbanPendingByTeamBucketDto,
    KanbanReportActivityItemDto,
    KanbanStatusSummaryDto,
} from "../dto/kanban-reports.dto";

@injectable()
export class ProjectKanbanReportsRepository {
    constructor(
        @inject(ProjectKanbanReportsDataSource)
        private readonly dataSource: ProjectKanbanReportsDataSource,
    ) {}

    getStatusSummary(
        projectId: number,
    ): Promise<Either<FallbackError, KanbanStatusSummaryDto>> {
        return this.dataSource.fetchStatusSummary(projectId);
    }

    getPending(
        projectId: number,
    ): Promise<Either<FallbackError, KanbanReportActivityItemDto[]>> {
        return this.dataSource.fetchPending(projectId);
    }

    getPendingByAssignee(
        projectId: number,
    ): Promise<Either<FallbackError, KanbanPendingByAssigneeBucketDto[]>> {
        return this.dataSource.fetchPendingByAssignee(projectId);
    }

    getPendingByTeam(
        projectId: number,
    ): Promise<Either<FallbackError, KanbanPendingByTeamBucketDto[]>> {
        return this.dataSource.fetchPendingByTeam(projectId);
    }
}
